import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TablerIconsModule } from 'angular-tabler-icons';
import { ToastrService } from 'ngx-toastr';
import { MaterialModule } from 'src/app/material.module';
import { MediclaimService } from '../mediclaim.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ValidationService } from 'src/app/common/validation/validation.service';
import { IMediclaim } from '../imediclaim';
import { TranslationUtils } from 'src/app/common/utils/translation.utils';

@Component({
  selector: 'app-mediclaim-detail',
  standalone: true,
  imports: [
    CommonModule,
    MaterialModule,
    TablerIconsModule,
    ReactiveFormsModule,
    TranslateModule
  ],
  templateUrl: './mediclaim-detail.component.html',
  styleUrl: './mediclaim-detail.component.scss'
})
export class MediclaimDetailComponent implements OnInit {

  mediclaimForm: FormGroup;
  isEdit: boolean = false;
  isLoading: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private _mediclaimservice: MediclaimService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private dialogRef: MatDialogRef<MediclaimDetailComponent>,
    private translationUtils: TranslationUtils,
    @Inject(MAT_DIALOG_DATA) private _data: { mediclaimdata: IMediclaim, isEdit: boolean },
  ) {
    this.isEdit = _data?.isEdit;
  }

  ngOnInit(): void {
    this.mediclaimForm = this.formBuilder.group({
      name: [this._data?.mediclaimdata?.name, [Validators.required, Validators.minLength(5)]],
      weburl: [
        this._data?.mediclaimdata?.weburl || '',
        [
          ValidationService.urlValidator
        ]
      ],
      isDefault: [this._data?.mediclaimdata?.isDefault || false],
    });
  }

  onSaveMediclaim() {
    const data = this.mediclaimForm.getRawValue();
    this._mediclaimservice.createMediclaim(data).subscribe((response) => {
      if (response.isSuccess) {
        this.dialogRef.close(response);
        this.toastr.success(this.translationUtils.getTranslatedMessage('COMMON.CREATE', this.translate.instant('ENTITY.MEDICLAIM')));
      }
      else {
        const allErrors = Object.values(response.errors).flat();
        this.toastr.error(allErrors.join("\n"));
      }
    });
  }

  onUpdateMediclaim() {
    const data =
    {
      ...this.mediclaimForm.getRawValue(),
      id: this._data?.mediclaimdata?.id
    };

    this._mediclaimservice.updateMediclaim(data).subscribe((response) => {
      if (response.isSuccess) {
        this.dialogRef.close(response);
        this.toastr.success(this.translationUtils.getTranslatedMessage('COMMON.UPDATE', this.translate.instant('ENTITY.MEDICLAIM')));
      }
      else {
        const allErrors = Object.values(response.errors).flat();
        this.toastr.error(allErrors.join("\n"));
      }
    });
  }

  OnCloseDialog() {
    this.dialogRef.close();
  }

}
